import { Col, Card, Carousel, Button, Row, ListGroup, Image, Placeholder } from "react-bootstrap";
// import Slider from "react-slick";
import FeatureIcons from './FeatureIcons';
import { formatListingData, formatPrice } from "../Functions";
import ButtonArrow from "./ButtonArrow";
import '../assets/scss/components/property-card.scss';

function PropertyCard({ property }) {
    const formattedData = formatListingData(property);
    const { land_use, serviced, newly_built, price, property_name, city, state, bathrooms, bedrooms, terrace, land_size, id, images } = formattedData;

    // const sliderSettings = {
    //     infinite: true,
    //     speed: 1500,
    //     slidesToShow: 3, // Show 2 labels at a time
    //     slidesToScroll: 1,
    //     autoplay: false,
    //     autoplaySpeed: 1400,
    //     arrows: false, // Hide navigation arrows
    //     responsive: [
    //         {
    //             breakpoint: 1400,
    //             settings: {
    //                 slidesToShow: 2,
    //                 autoplay: true,
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1,
    //                 autoplay: true,
    //             }
    //         },
    //         {
    //             breakpoint: 576,
    //             settings: {
    //                 slidesToShow: 2,
    //                 autoplay: true,
    //             }
    //         },
    //         {
    //             breakpoint: 350,
    //             settings: {
    //                 slidesToShow: 1,
    //                 autoplay: true,
    //             }
    //         },
    //     ]
    // };

    return (
        <Card className="property border-0 mx-auto mx-lg-0 px-0">
            {/* Property Images */}
            <Carousel touch pause="hover" className="border-0">
                { images?.length > 0 ? (
                    images.map((image, index) => (
                        <Carousel.Item key={index}>
                            <Image src={ image }/> 
                        </Carousel.Item>
                    ))) :
                    <Carousel.Item key="placeholder">
                        <Placeholder as="img" animation="glow" />
                    </Carousel.Item>
                }
            </Carousel>

            {/* Property Labels */}
            <ListGroup className="property-label d-flex flex-row gap-1 border-0 align-items-center">
                {/* <Slider {...sliderSettings} className="sliding-label w-50"> */}
                    {land_use && <ListGroup.Item className="d-inline bg-secondary border-0 rounded-0 text-uppercase">{ land_use }</ListGroup.Item>}
                    {serviced && <ListGroup.Item className="d-inline bg-secondary border-0">SERVICED</ListGroup.Item>}
                    <ListGroup.Item className="build-status d-inline border-0">
                        { newly_built ? "NEWLY BUILT" : "RESALE" }
                    </ListGroup.Item>
                {/* </Slider> */}
                <ListGroup.Item className="h2 text-secondary fw-semibold fs-5 border border-primary border-end-0 rounded-start-3 rounded-end-0 px-2 position-absolute end-0"> { formatPrice(price) }</ListGroup.Item>
            </ListGroup>

            {/* Property Summary */}
            <Card.Body className="py-3 d-flex flex-column">
                <Card.Title className="text-secondary fw-semibold">{ property_name }</Card.Title>
                <Card.Text as={Row} className="py-3 mb-2">
                    <Col className="property-location">{ city }, { state }</Col>
                    <Col className="feature-summary" xs="auto" sm="auto">
                        <FeatureIcons
                            numOfBedrooms={ bedrooms ? bedrooms : null }
                            numOfBathrooms={ bathrooms ? bathrooms : null }
                            numOfTerraces={ terrace ? terrace : null }
                            landSize={ !bedrooms && land_size ? land_size : null }
                        />
                    </Col>
                </Card.Text>
                <Button href={`/properties/${id}`} className="card-button border border-primary px-4 py-2 mx-auto">View Property <ButtonArrow /></Button>
            </Card.Body>
        </Card>
    )
};

export default PropertyCard;
